import { TypographyProps } from '@mui/material';
import { SystemColors } from 'melp-design/style';

export const typographyVariants = [
  'h1',
  'h2',
  'h3',
  'h4',
  'p1',
  'p2',
  'p3',
] as const;
export type TypographyVariant = (typeof typographyVariants)[number];

export const typographyColors = [
  'textPrimary',
  'textSecondary',
  'textWhite',
  'primary',
  'error',
  'warning',
  'success',
  'inherit',
] as const;
export type TypographyColor = (typeof typographyColors)[number];

export const COLOR_BY_TYPOGRAPHY_COLOR: Record<TypographyColor, string> = {
  textPrimary: SystemColors.black,
  textSecondary: SystemColors.grey[55],
  textWhite: SystemColors.white,
  primary: SystemColors.primary.base,
  error: SystemColors.danger.base,
  warning: SystemColors.warning.base,
  success: SystemColors.success.base,
  inherit: 'inherit',
};

export const FONT_SIZE_BY_VARIANT: Record<TypographyVariant, number> = {
  h1: 30,
  h2: 18,
  h3: 14,
  h4: 12,
  p1: 14,
  p2: 12,
  p3: 10,
};

export const FONT_WEIGHT_BY_VARIANT: Record<TypographyVariant, number> = {
  h1: 500,
  h2: 500,
  h3: 500,
  h4: 600,
  p1: 400,
  p2: 400,
  p3: 400,
};

export const LINE_HEIGHT_BY_VARIANT: Record<TypographyVariant, number> = {
  h1: 1.1,
  h2: 1.4,
  h3: 1.4,
  h4: 1.4,
  p1: 1.4,
  p2: 1.4,
  p3: 1.4,
};

export const MUI_VARIANT_BY_VARIANT: Record<
  TypographyVariant,
  TypographyProps['variant']
> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  p1: 'body1',
  p2: 'body2',
  p3: 'body1',
};
